import React from 'react';
import { Drawer as AntDrawer } from 'antd';
import Skeleton from '../Skeleton/Skeleton';

/**
 * @typedef {'right'|'left'|'bottom'} DrawerPlacement
 * @typedef {'sm'|'md'|'lg'} DrawerSize
 */

const SIZE_WIDTH = {
  sm: 360,
  md: 480,
  lg: 640,
};

/**
 * Shared Drawer (offcanvas) component.
 * If loading={true}, renders Skeleton instead of children.
 *
 * @param {object}          props
 * @param {boolean}         props.open
 * @param {() => void}      props.onClose
 * @param {React.ReactNode} [props.title]
 * @param {React.ReactNode} props.children
 * @param {DrawerPlacement} [props.placement='right']
 * @param {DrawerSize}      [props.size='md']
 * @param {React.ReactNode} [props.footer]
 * @param {boolean}         [props.loading]
 */
const Drawer = ({
  open,
  onClose,
  title,
  children,
  placement = 'right',
  size = 'md',
  footer,
  loading,
}) => (
  <AntDrawer
    open={open}
    onClose={onClose}
    title={title}
    placement={placement}
    width={SIZE_WIDTH[size]}
    footer={footer}
    destroyOnHidden
    push={false}
  >
    {loading ? <Skeleton rows={5} /> : children}
  </AntDrawer>
);

export default Drawer;
